import React from "react";
import Svg from "react-native-svg";
import { useColorTokens, useTheme } from "../../theming";
import { useIconSize, useQaLabel } from "../../hooks";
import IconContent from "./iconContent";
import { IconProps, IconNames } from "./types";
import { Container } from "./styled-components";
import { getDefaultColor } from "./utils";
import { useIconList, useIsValidIcon } from "./hooks/index";

export const Icon = React.memo(
  ({
    name,
    size,
    lineColor,
    backgroundColor,
    qaLabel,
    ariaLabel,
    shouldUseColorTokens,
    overrideSize,
    ...props
  }: IconProps) => {
    const { colors } = useTheme();
    const { iconSize, strokeWidth } = useIconSize(size);
    const viewTestProps = useQaLabel(qaLabel || name);
    const iconColor = getDefaultColor(name, colors, {
      line: lineColor,
      background: backgroundColor
    });
    const lineColorValue =
      lineColor && lineColor?.indexOf("#") > -1 ? lineColor : iconColor.line;
    const backgroundColorValue =
      backgroundColor &&
      backgroundColor?.includes("#") &&
      backgroundColor?.includes("transparent")
        ? backgroundColor
        : iconColor.background;

    return (
      <Container {...props}>
        <Svg
          width={overrideSize ?? iconSize}
          height={overrideSize ?? iconSize}
          viewBox="0 0 24 24"
          fill="none"
          accessibilityLabel={ariaLabel || name}
          // @ts-ignore
          tabIndex="0"
          {...viewTestProps}
          {...props}
        >
          <IconContent
            iconName={name}
            lineColor={
              shouldUseColorTokens ? useColorTokens(lineColor) : lineColorValue
            }
            backgroundColor={backgroundColorValue}
            strokeWidth={strokeWidth}
          />
        </Svg>
      </Container>
    );
  }
);

export { useIconList, useIsValidIcon };
export type { IconNames };
export default Icon;
